import React from "react";
import Show from "../../../../../utils/show.component";
import { popupMenuOptions } from "../../../parent/data/popupMenuOptions";

export const ResetPinPopupButton = ({
  setCardInfo,
  AgreeNbr,
}) => {
  const onClick = () => {
    window.scrollTo(0, 0);
    setCardInfo((state) => {
      return {
        ...state,
        agreeNbr: AgreeNbr,
        type: popupMenuOptions.valid.ResetPIN,
      };
    });
  };

  return (
    <Show condition={true}>
      <li>
        <button
          className="f12 mt-0 auth-card-popup-button"
          onClick={onClick}
          data-e2e-id={"resetpin"}
        >
          Reset PIN
        </button>
      </li>
    </Show>
  );
};



// WEBPACK FOOTER //
// ./src/components/card-controls/card/menu/popup-menu-buttons/reset-pin-popup-button.component.js